import { render, staticRenderFns } from "./squareDetail.vue?vue&type=template&id=86086476&scoped=true"
import script from "./squareDetail.vue?vue&type=script&lang=js"
export * from "./squareDetail.vue?vue&type=script&lang=js"
import style0 from "./squareDetail.vue?vue&type=style&index=0&id=86086476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86086476",
  null
  
)

export default component.exports